import { useQuery } from '@tanstack/react-query'

import { useServer } from 'app/server/context'
import keys from 'chat/shared/queries/keys'
import { MINS_TO_MS } from 'shared/constants'
import { RetryQuery } from 'shared/queries/utils'
import { convertChatConfig } from './shared/convert'
import * as Response from './shared/response'
import { ChatConfigData } from './shared/types'

export function useChatConfig(retryQuery?: RetryQuery) {
  const { server } = useServer()

  return useQuery<ChatConfigData>({
    queryKey: keys.config(),
    queryFn: fetchChatConfig,
    staleTime: 15 * MINS_TO_MS,
    retry: retryQuery ?? false,
  })

  async function fetchChatConfig() {
    const response = await server.get<Response.ChatConfig>('/v2/chat/config/')
    return convertChatConfig(response)
  }
}
